/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.right_panel.init());

App.right_panel = {
  init() {
    $(document)
      .off("click", "[rel=right-panel]", App.right_panel.link_clicked)
      .on("click", "[rel=right-panel]", App.right_panel.link_clicked);

    return $(document)
      .off("click", ".js-right-panel-close", App.right_panel.close_clicked)
      .on("click", ".js-right-panel-close", App.right_panel.close_clicked);
  },

  close() {
    $("body").removeClass("right-panel-open");
    return App.right_panel.unhighlight_context();
  },
    
  close_clicked(evt) {
    evt.preventDefault();
    $(this).closest(".js-right-panel").removeClass("open");
    return App.right_panel.close();
  },

  open() {
    return $("body").addClass("right-panel-open");
  },

  highlight_context(trigger) {
    App.right_panel.unhighlight_context();
    return trigger.closest(trigger.attr("data-context")).addClass("right-panel-context-highlight");
  },

  unhighlight_context() {
    return $(".right-panel-context-highlight").removeClass("right-panel-context-highlight");
  },

  link_clicked(evt) {
    evt.preventDefault();
    const trigger = $(this);
    App.right_panel.highlight_context(trigger);
    return App.right_panel.load(trigger.attr("href"));
  },

  load(url, callback) {
    return $.get(url, function(data, status, xhr) {
      App.right_panel.remote_success(data, status, xhr);
      if (callback) { return callback(); }
    });
  },

  // - on success, 
  //   - append response to right-panel container
  //   - show right_panel
  remote_success(data, status, xhr) {
    $(".js-right-panel-container").html(data);
    return App.right_panel.remote_show();
  },

  remote_show(id) {
    App.right_panel.open();
    // Wait a few ticks so the css animations work
    return window.setTimeout((() => $(".js-right-panel-container").find(".right-panel").addClass("open")), 50);
  }
};
